var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.cupons,"label":"Cupons","item-text":"text","item-value":"value"},model:{value:(_vm.cupomSelecionado),callback:function ($$v) {_vm.cupomSelecionado=$$v},expression:"cupomSelecionado"}})}
var staticRenderFns = []

export { render, staticRenderFns }